import React from 'react'

function ErrorBox({children}) {
  return (
    <div className='error-box'>{children}</div>
  )
}

export default ErrorBox